import React from 'react';
import { SliderThumb } from '@mui/material';

const CustomSliderThumb = (props) => {
  const { children, ...other } = props;
  return (
    <SliderThumb {...other}>
      {children}
      <Lines />
    </SliderThumb>
  );
};

const Lines = () => (
  <img src="/-/jssmedia/Project/FAB2/shared/images/icon_slider-indicator.svg" alt="" />
);

export default CustomSliderThumb;
